import React, { useCallback, useState, memo } from 'react';
import { ReactFlow, Node, Edge, Controls, Background, useNodesState, useEdgesState, ConnectionLineType, MarkerType, Panel } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import FlowNode from './FlowNode';
const nodeWidth = 200;
const nodeHeight = 50;
const nodeGap = 80;
const initialNodes: Node[] = [{
  id: '1',
  type: 'flowNode',
  position: {
    x: 250,
    y: 0
  },
  data: {
    label: 'Create project from template'
  }
}, {
  id: '2',
  type: 'flowNode',
  position: {
    x: 250,
    y: nodeHeight + nodeGap
  },
  data: {
    label: 'Upload documents'
  }
}, {
  id: '3',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 2
  },
  data: {
    label: 'Run extractions'
  }
}, {
  id: '4',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 3
  },
  data: {
    label: 'Spot omissions or data issues'
  }
}, {
  id: '5',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 4
  },
  data: {
    label: 'Run evaluation criteria'
  }
}, {
  id: '6',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 5
  },
  data: {
    label: 'Run red flag analysis'
  }
}, {
  id: '7',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 6
  },
  data: {
    label: 'Run memo generation'
  }
}, {
  id: '8',
  type: 'flowNode',
  position: {
    x: 250,
    y: (nodeHeight + nodeGap) * 7
  },
  data: {
    label: 'Copy to google docs'
  }
}, {
  id: 'x',
  type: 'flowNode',
  position: {
    x: 550,
    y: (nodeHeight + nodeGap) * 4.5
  },
  data: {
    label: 'Deep dive / export to excel for modeling'
  }
}];
// Define the edges (connections between nodes)
const initialEdges: Edge[] = [
// Main flow (solid lines with smooth curves)
{
  id: 'e1-2',
  source: '1',
  target: '2',
  sourceHandle: 'bottom',
  // Explicitly use bottom handle
  targetHandle: 'top',
  // Explicitly use top handle
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e2-3',
  source: '2',
  target: '3',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e3-4',
  source: '3',
  target: '4',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e4-5',
  source: '4',
  target: '5',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e5-6',
  source: '5',
  target: '6',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e6-7',
  source: '6',
  target: '7',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
}, {
  id: 'e7-8',
  source: '7',
  target: '8',
  sourceHandle: 'bottom',
  targetHandle: 'top',
  animated: false,
  style: {
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.6)'
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: 'rgba(255, 255, 255, 0.8)'
  },
  type: 'smoothstep',
  pathOptions: {
    borderRadius: 20
  },
  className: 'flow-edge'
},
// Dotted lines to deep dive (curved bezier lines)
{
  id: 'e4-x',
  source: '4',
  target: 'x',
  sourceHandle: 'right',
  // Add this to make it originate from right side
  targetHandle: 'left',
  // Add this to make it go to left side
  style: {
    strokeDasharray: '5, 5',
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.5)'
  },
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 18,
    height: 18,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  type: 'bezier',
  className: 'flow-edge-animated'
}, {
  id: 'e5-x',
  source: '5',
  target: 'x',
  sourceHandle: 'right',
  // Add this
  targetHandle: 'left',
  // Add this
  style: {
    strokeDasharray: '5, 5',
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.5)'
  },
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 18,
    height: 18,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  type: 'bezier',
  className: 'flow-edge-animated'
}, {
  id: 'e6-x',
  source: '6',
  target: 'x',
  sourceHandle: 'right',
  // Add this
  targetHandle: 'left',
  // Add this
  style: {
    strokeDasharray: '5, 5',
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.5)'
  },
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 18,
    height: 18,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  type: 'bezier',
  className: 'flow-edge-animated'
}, {
  id: 'e7-x',
  source: '7',
  target: 'x',
  sourceHandle: 'right',
  // Add this
  targetHandle: 'left',
  // Add this
  style: {
    strokeDasharray: '5, 5',
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.5)'
  },
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 18,
    height: 18,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  type: 'bezier',
  className: 'flow-edge-animated'
},
// Dotted line from deep dive back to upload (curved)
{
  id: 'ex-2',
  source: 'x',
  target: '2',
  sourceHandle: 'right',
  // Originate from right side
  targetHandle: 'right-target',
  // Land on right side using the special target handle
  style: {
    strokeDasharray: '5, 5',
    strokeWidth: 2,
    stroke: 'rgba(255, 255, 255, 0.5)'
  },
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 18,
    height: 18,
    color: 'rgba(255, 255, 255, 0.7)'
  },
  type: 'bezier',
  className: 'flow-edge-animated'
}];
// Define the node types
const nodeTypes = {
  flowNode: FlowNode
};
const FlowDiagram = () => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  return <div className="w-full h-full" data-id="element-2">
      <ReactFlow nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} nodeTypes={nodeTypes} fitView className="dark-flow" data-id="element-3">
        <Controls className="controls-dark" data-id="element-4" />
        <Background color="rgba(255, 255, 255, 0.1)" gap={20} size={1} variant="dots" data-id="element-5" />
        <style jsx global data-id="element-6">{`
          .dark-flow {
            background: transparent;
          }
          .controls-dark {
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(8px);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          }
          .controls-dark button {
            background: rgba(255, 255, 255, 0.05);
            color: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(255, 255, 255, 0.1);
            transition: all 0.2s ease;
          }
          .controls-dark button:hover {
            background: rgba(255, 255, 255, 0.1);
            color: white;
          }
          .flow-edge {
            transition:
              stroke 0.3s ease,
              stroke-width 0.3s ease;
          }
          .flow-edge:hover {
            stroke: rgba(255, 255, 255, 0.9) !important;
            stroke-width: 3px !important;
            filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.6));
          }
          .flow-edge-animated path {
            stroke-dasharray: 5, 5;
            animation: flowDash 1s linear infinite;
          }
          .flow-edge-animated:hover {
            stroke: rgba(255, 255, 255, 0.8) !important;
            stroke-width: 3px !important;
            filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.5));
          }
          @keyframes flowDash {
            to {
              stroke-dashoffset: -10;
            }
          }
          .react-flow__attribution {
            display: none !important;
          }
        `}</style>
      </ReactFlow>
    </div>;
};
export default FlowDiagram;